import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";

import { Box } from "@mui/material";

// core components
import styles from "../../assets/jss/material-dashboard-react/components/cardIconStyle.js";
import { getBaseSxStyle, getKeyArray } from "../../utils/getSxStyle.js";


export default function CardIcon(props) {
  const { className, children, color, ...rest } = props;

  const targetData = {
    'cardIcon': true,
    [color + "CardHeader"]: color,
  };

  const keyArray = getKeyArray(targetData);

  return (
    <Box sx={getBaseSxStyle(styles, keyArray)} {...rest}>
      {children}
    </Box>
  );
}

CardIcon.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf([
    "warning",
    "success",
    "danger",
    "info",
    "primary",
    "rose"
  ]),
  children: PropTypes.node
};
